import apiSlice from './apiSlice';
import type {
  CasinoGroupedGamesQueryParams,
  CasinoGroupedGamesResponse,
  CasinoGamesQueryParams,
  CasinoGamesResponse,
  CasinoProvidersQueryParams,
  CasinoProvidersResponse,
  CreateCasinoSessionRequest,
  CreateCasinoSessionResponse,
} from '@/types/casino';

export const casinoApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCasinoCategories: builder.query<{ games: string[] }, { search?: string; provider?: string }>(
      {
        query: (params) => {
          return {
            url: `/casino/category`,
            method: 'GET',
            params,
          };
        },
        // providesTags: ['CasinoCategories'],
      }
    ),

    getCasinoProviders: builder.query<CasinoProvidersResponse, CasinoProvidersQueryParams | void>({
      query: (params) => {
        return {
          url: `/casino/providers`,
          method: 'GET',
          params: { ...params, status: 'Active' },
        };
      },
      // providesTags: ['CasinoProviders'],
    }),

    getCasinoGames: builder.query<CasinoGamesResponse, CasinoGamesQueryParams | void>({
      query: (params) => ({
        url: '/casino/games',
        method: 'GET',
        params: {
          ...params,
          status: 'ACTIVE',
        },
      }),
    }),

    getCasinoGamesGrouped: builder.query<
      CasinoGroupedGamesResponse,
      CasinoGroupedGamesQueryParams | void
    >({
      query: (params) => ({
        url: '/casino/games/grouped',
        method: 'GET',
        ...(params && { params }),
      }),
    }),

    createCasinoSession: builder.mutation<CreateCasinoSessionResponse, CreateCasinoSessionRequest>({
      query: ({ id, platform }) => ({
        url: `/casino/create-session/${id}`,
        method: 'POST',
        body: { platform },
      }),
    }),
  }),
});

export const {
  useGetCasinoCategoriesQuery,

  useGetCasinoProvidersQuery,
  useLazyGetCasinoProvidersQuery,

  useGetCasinoGamesQuery,
  useLazyGetCasinoGamesQuery,
  useGetCasinoGamesGroupedQuery,

  useCreateCasinoSessionMutation,
} = casinoApi;
